module.exports = __webpack_public_path__ + "static/media/search.4d74eb23.svg";